<carousel [showIndicators]="showIndicator">
  <slide *ngFor="let slide of slides; let index=index">
    <img [src]="slide.image" alt="image slide" style="display: block; width: 100%;">

    <div class="carousel-caption">
      <h4>Slide {{index}}</h4>
      <p>{{slide.text}}</p>
    </div>
  </slide>
</carousel>
<br/>
<div>
  <button type="button" class="btn btn-info"
          (click)="switchIndicator()">Enable/Disable Indicator
  </button>
</div>
